export enum AuthRoutePath {
  Login = 'login',
  Register = 'register',
}
